




























































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons/faCircle';
import { faDotCircle } from '@fortawesome/free-regular-svg-icons/faDotCircle';

import bListGroup from 'bootstrap-vue/es/components/list-group/list-group';
import bListGroupItem from 'bootstrap-vue/es/components/list-group/list-group-item';

import FullscreenModal from '@/components/FullscreenModal.vue';
import PriceBlock from '@/components/PriceBlock.vue';
import AvailabilityBlock from '@/components/AvailabilityBlock.vue';

import {
  ProductOption,
  ProductOptionValue,
  ProductVariant,
} from '@/models';

interface MobilePaletteOptionValue extends ProductOptionValue {
  // optionVariant is the variant whose option values are same as current selected variant except
  // for the one to the current option (i.e., the extended ProductOptionValue). This is undefined if
  // there's no such one.
  optionVariant?: ProductVariant;
  // valueVariants is the all variants that contains the same value as the current selected variant
  // for the current option.
  valueVariants?: ProductVariant[];
  isSelected: boolean;
}

const MobilePaletteModalProps = Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
});

@Component({
  components: {
    AvailabilityBlock,
    FontAwesomeIcon,
    FullscreenModal,
    PriceBlock,

    bListGroup,
    bListGroupItem,
  },
})
export default class MobilePaletteModal extends MobilePaletteModalProps {
  public readonly faCircle = faCircle;
  public readonly faDotCircle = faDotCircle;

  public optionValues(props: {
    option: ProductOption,
    value: string,
    optionVariants: Map<string, ProductVariant>,
    valueVariants: Map<string, ProductVariant[]>,
  }) {
    const {
      option,
      value: curValue,
      optionVariants,
      valueVariants: allValueVariants,
    } = props;
    return option.values.map<MobilePaletteOptionValue>((value) => (
      Object.assign({
        optionVariant: optionVariants.get(value.value),
        valueVariants: allValueVariants.get(value.value),
        isSelected: value.value === curValue,
      }, value)));
  }

  public onOptionValueClicked(optionValue: MobilePaletteOptionValue) {
    let variant: ProductVariant;
    if (optionValue.optionVariant) {
      variant = optionValue.optionVariant;
    } else if (optionValue.valueVariants && optionValue.valueVariants.length > 0) {
      variant = optionValue.valueVariants[0];
    } else {
      return false;
    }
    this.$emit('select-variant', variant);
    this.$nextTick(() => this.$root.$emit('hide::fullscreen::modal', this.id));
  }
}

